import React from 'react';
import { Select } from 'antd';
import { SearchOutlined, LoadingOutlined, CloseOutlined } from '@ant-design/icons';
import './LocationSearchSelect.css';

/**
 * LocationSearchSelect — shared "Select a location" combobox used by both
 * ClinicBooking.js and PreferredTime.js. Icons are wrapped in dedicated
 * .loc-suffix-icon / .loc-clear-icon spans (own background/color/shape)
 * instead of relying on antd's shared .ant-select-arrow / .ant-select-clear
 * classes, which are also targeted by unrelated Select styling elsewhere
 * in the app and would otherwise fight over the same properties. Visibility
 * (search icon vs. clear icon, shown only on hover/when a value is picked)
 * is left entirely to antd's own default toggle — do not force opacity on
 * either wrapper, that's what caused them to render on top of each other.
 *
 * Props:
 *   options         {Array}     antd Select options (address suggestions)
 *   loading         {boolean}   show spinner instead of the search icon
 *   searchValue     {string}    current typed search text (controls notFoundContent)
 *   onSearch        {function}  called with the typed value
 *   onSelect        {function}  called with the chosen value
 */
const LocationSearchSelect = ({ options, loading, searchValue, onSearch, onSelect }) => (
  <Select
    showSearch
    allowClear={{ clearIcon: <span className="loc-clear-icon"><CloseOutlined /></span> }}
    placeholder="Select a location"
    className="location-search-select"
    onChange={(value) => value && onSelect(value)}
    onSearch={onSearch}
    options={options ?? []}
    filterOption={false}
    suffixIcon={<span className="loc-suffix-icon">{loading ? <LoadingOutlined spin /> : <SearchOutlined />}</span>}
    notFoundContent={searchValue ? undefined : null}
  />
);

export default LocationSearchSelect;
